export const selectPersonalNetwork = (state) => state.PersonalNetwork;

export const selectBuddiesState = (state) => selectPersonalNetwork(state).buddies;

export const selectBuddiesList = (state) => selectBuddiesState(state).buddies;
export const selectBuddiesTotal = (state) => selectBuddiesState(state).total;
export const selectBuddiesLoading = (state) => selectBuddiesState(state).loading;
export const selectBuddiesInitialLoad = (state) => selectBuddiesState(state).initialLoad;

export const selectBuddiesFacets = (state) => selectBuddiesState(state).facets;
export const selectBuddiesFacetsLoading = (state) => selectBuddiesState(state).facetsLoading;
export const selectBuddiesFilters = (state) => selectBuddiesState(state).filters;

export const buildBuddiesQueryParams = (baseParams = {}, filters = {}) => {
  const params = { ...baseParams };

  if (filters.jobRole) {
    params.job_role = filters.jobRole;
  }

  if (filters.city) {
    params.city = filters.city;
  }
  if (filters.state) {
    params.state = filters.state;
  }
  if (filters.country) {
    params.country = filters.country;
  }

  return params;
};